import { render } from "./company-sons.vue?vue&type=template&id=e88237d0&scoped=true"
import script from "./company-sons.vue?vue&type=script&lang=js"
export * from "./company-sons.vue?vue&type=script&lang=js"

import "./company-sons.vue?vue&type=style&index=0&id=e88237d0&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88237d0"]])

export default __exports__